import type { Data } from '@wix/thunderbolt-becky-types'

export const ShapeDividerBuilderID = 'wixSystemElements.BackgroundShapeDivider'

export const RELEVANT_DATA_MAPS: Array<keyof Data> = [
	'document_data',
	'design_data',
	'component_properties',
	'theme_data',
	'cursor',
	'variants_data',
	'innerElements',
]
